export const extractError = err => {
  if (err.message && err.message.errors) {
    return err.message.errors[0].developerMessage;
  }
  if (err.message && err.message.error) {
    return err.message.error;
  }
  return "Something went wrong";
};
